import ContactsTypes from 'components/contacts/ContactsTypes';
import React from 'react';

function ContactTypePage() {
  return (
    <div className="rightContent">
      <ContactsTypes />
    </div>
  );
}

export default ContactTypePage;
